__turbopack_context__.v({
  "help": "help-tip-module__hS2GIa__help",
  "panel": "help-tip-module__hS2GIa__panel",
});
